export default __webpack_public_path__ + "static/media/chigo-mobile-2.fd8a00d4.png";